/* eslint-disable import/extensions */
import { useCallback } from 'react'
import { SortType } from 'rsuite-table'
import { Table, Toolbar } from 'shared'
import { useTableHandlers } from 'hooks/useTableHandlers'
import { Operator, IFilter } from 'api/types'
import { useNavigate } from 'react-router'
import { Company, CompanyListRequest } from '../types'
import { ACTIVE_TAB } from '../utils'
import './CompanyList.scss'
import { useGetCompanyQuery } from '../companyApiSlice'

const { Column, HeaderCell, Cell, VerifyStatusCell } = Table

const COLUMNS = [
  { key: 'name', label: 'Name' },
  { key: 'websiteUrl', label: 'Website' },
  { key: 'phoneNo', label: 'Phone' },
  { key: 'email', label: 'Email' }
]

const CompanyList = () => {
  const navigate = useNavigate()
  const {
    requestBody,
    onPageChange,
    onSearchChange,
    onSortColumn,
    onFilterChange
  } = useTableHandlers<Company, CompanyListRequest>(
    {
      filters: [],
      page: { size: 10, number: 0 }
    },
    'name'
  )
  const { data, isFetching } = useGetCompanyQuery(requestBody)
  const total = data?.totalElements ?? data?.content?.length ?? 0

  const handleSortColumn = useCallback(
    (column: string, type?: SortType) => {
      onSortColumn(column, type)
    },
    [onSortColumn]
  )
  const handleTabChange = (tab: ACTIVE_TAB) => {
    let fieldValue
    switch (tab) {
      case ACTIVE_TAB.ALL:
        fieldValue = 'all'
        break
      default:
        fieldValue = 'all'
    }

    const newFilter: IFilter<Company> = {
      fieldName: 'name',
      operator: Operator.EQ,
      fieldValue: fieldValue ?? 'all'
    }

    onFilterChange([newFilter])
  }

  const options = [
    {
      label: 'All',
      value: ACTIVE_TAB.ALL,
      onClick: () => handleTabChange(ACTIVE_TAB.ALL)
    }
  ]
  const handleRowCLick = (rowData: any) => {
    navigate(`/document-verification/company/${rowData?.id}`, {
      replace: true
    })
  }
  return (
    <div className="user-list">
      <Toolbar
        options={options}
        onSearchChange={onSearchChange}
        total={total}
      />
      <div className="user-list__main-container">
        <Table
          data={data?.content ?? []}
          loading={isFetching}
          onSortColumn={handleSortColumn}
          onRowClick={handleRowCLick}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={data?.size ?? 10}
          onPageChange={onPageChange}
        >
          {COLUMNS.map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                <Cell dataKey={key} tooltip />
              </Column>
            )
          })}
          <Column flexGrow={1} key="Status" sortable>
            <HeaderCell>Status</HeaderCell>
            <VerifyStatusCell
              negDataLabel="Inactive"
              posDataLabel="Active"
              dataKey="active"
            />
          </Column>
        </Table>
      </div>
    </div>
  )
}

export default CompanyList
